import {DashboardCard, Loading} from '@hm/fundamental'
import React, {Suspense} from 'react'

import {useFeaturesMenu} from '../welcomeFlow/useFeaturesMenu'

import {featureComponentMap} from './featureContentMap'
import {useFeatureName} from './useFeatureName'

export const FeatureRoutes: React.FC = () => {
  const featureName = useFeatureName()
  const FeatureComponent = featureComponentMap[featureName]

  const {featuresMenu} = useFeaturesMenu()
  if (!featuresMenu) {
    throw new Error('BUG: Features menu should be loaded before rendering feature routes')
  }

  if (!FeatureComponent) {
    return <DashboardCard>Feature content not found: {featureName}</DashboardCard>
  }

  return (
    <Suspense
      fallback={
        <div className="h-screen flex items-center justify-center">
          <Loading size="xlarge" />
        </div>
      }
    >
      <FeatureComponent />
    </Suspense>
  )
}
